var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimerPreview',{attrs:{"timer":_vm.timer,"empty":_vm.empty,"gallery":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }